import React from 'react';
import styled from '@emotion/styled';
import { ColumnLayout } from '../../../../../../ui';
import {
	SubcategoryRadioButton,
	StyledSubcategoryRadioButton,
} from './SubcategoryRadioButton';
import { ISubcategory } from './types';
import { SubcategoryRadioButtonBlank } from './SubcategoryRadioButtonBlank';

interface ISubcategoriesProps<TCategoryId, TSubcategoryId> {
	categoryId: TCategoryId;
	subcategories: ISubcategory<TSubcategoryId>[];
	defaultSubcategoryId?: TSubcategoryId;
}

export const Subcategories = <
	CategoryId extends string | number,
	TSubcategoryId extends string | number,
>({
	categoryId,
	subcategories,
	defaultSubcategoryId,
}: ISubcategoriesProps<CategoryId, TSubcategoryId>) => {
	// The 'blank' subcategory should use the same Nested Input Kevel as its sibling(s)
	const blankNestedInputLevel = subcategories[0]?.nestedInputLevel;

	return (
		<StyledSubcategories>
			{subcategories.map((subcategory) => (
				<SubcategoryRadioButton
					key={subcategory.id}
					categoryId={categoryId}
					defaultChecked={defaultSubcategoryId === subcategory.id}
					subcategory={subcategory}
				/>
			))}
			<SubcategoryRadioButtonBlank nestedInputLevel={blankNestedInputLevel} />
		</StyledSubcategories>
	);
};

const StyledSubcategories = styled(ColumnLayout)`
	margin-top: -8px;
	margin-bottom: 8px;
	break-inside: avoid;

	${StyledSubcategoryRadioButton} {
		padding-top: 16px;
	}
`;
